<template>
    <div class="delivery-sec__body" v-if="this.$store.state.settings.site_id === 1">
        <ForbuyersRu/>
    </div>
    <div class="delivery-sec__body" v-if="this.$store.state.settings.site_id === 2">
        <ForbuyersEn/>
    </div>
</template>

<script>
import ForbuyersRu from './ru/forbuyers.vue'
import ForbuyersEn from './en/forbuyers.vue'
export default {
    components:{
        ForbuyersRu,ForbuyersEn
    },
    name: "forbuyers"
}
</script>

<style scoped>

</style>
